<template>
    <ValidationObserver ref="form">
        <div class="box box-w-1" @keyup.enter="submit">
            <div class="box-inner">
                <h2>Login</h2>
                <div class="text-center">
                    <p>Please login using your existing account</p>
                </div>
                <div class="form">
                    <div class="row">
                        <ValidationProvider name="Email" rules="required|email" v-slot="{errors}" class="col-sm-12">
                            <div class="form-group form-group-1">
                                <input
                                    type="email"
                                    class="form-control"
                                    v-model="form.email"
                                    placeholder="Email"
                                >
                                <FormError :error="errors[0]" name="Email"></FormError>
                            </div>
                        </ValidationProvider>

                        <ValidationProvider name="Password" rules="required" v-slot="{errors}" class="col-sm-12">
                            <div class="form-group form-group-1">
                                <input type="password" class="form-control" placeholder="Password"
                                       v-model="form.password">
                                <FormError :error="errors[0]" name="Password"></FormError>
                            </div>
                        </ValidationProvider>

                        <div class="col-sm-6 ">
                            <div class="form-group form-group-1">
                                <div class="form-check">
                                    <input class="form-check-input-checkbox" type="checkbox" v-model="form.remember"
                                           id="home-office">
                                    <label class="form-check-label" for="home-office">
                                        Remember Me
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 text-center text-sm-right">
                            <div class="form-group form-group-1">
                                <a href="/master-admin/password-recovery" class="">Forgot Password?</a>
                            </div>
                        </div>
                        <div class="col-12">
                            <button class="btn btn--secondary w-100" @click="submit">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
import LoginFormService from "../services/LoginFormService";

export default {
    name: 'MasterAdminLogin',
    data() {
        return {
            form: {
                email: null,
                password: null,
                remember: false
            }
        }
    },
    methods: {
        async submit() {
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorSwal();
                return;
            }

            try {
                await LoginFormService.loginMasterAdmin(this.form);
                const response = await axios.get('/master-admin/api/intended-url');
                window.location.href = response.data.intended;
            } catch (error){
                if (error) {
                    this.$showErrorMessage(`${error.response.data.error}`);
                }
            }
        }
    }
}


</script>

<style scoped>

</style>
